import script from "./InfoTicketItem.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoTicketItem.vue?vue&type=script&setup=true&lang=js"

import "./InfoTicketItem.vue?vue&type=style&index=0&id=71c32660&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c32660"]])

export default __exports__